/* eslint-disable */
// FrameDetailStage — left spotlight stage of the Frame Detail panel. Spotlit
// hero image with warm-ink floor shadow, eyebrow + title + SKU overlaid top-left,
// dev-count exhibition tag top-right, thumbnail strip, click-to-zoom (Lightbox).
import React from "react";
import { SmartImg } from "../../utils";
import styles from "./FrameDetailModal.module.css";

export default function FrameDetailStage({ selected, imgs, activeImg, detailImgIdx, setDetailImgIdx, devCount, onZoom }) {
  return (
    <div className={styles.stage}>
      <div className={styles.stageHead}>
        <div className={styles.eyebrow}>Carolina Lemke Berlin · Frame Detail</div>
        <div className={styles.stageTitle}>{selected.brand || "—"}</div>
        {(selected.sku || selected.model) && <div className={styles.stageSku}>{selected.sku || selected.model}</div>}
      </div>

      {devCount > 0 && (
        <div className={styles.exhibitTag}>↩ {devCount} dev{devCount === 1 ? "" : "s"}</div>
      )}

      {activeImg
        ? <SmartImg src={activeImg} displayWidth={500} alt="" className={styles.stageImg} onClick={onZoom} />
        : <div className={styles.stageEmpty}>CAROLINA LEMKE</div>}
      <span className={styles.stageFloor} aria-hidden="true" />
      {activeImg && <div className={styles.zoomHint}>Click to zoom</div>}

      {imgs.length > 1 && (
        <div className={styles.thumbs}>
          {imgs.map((img, i) => (
            <div key={i} className={`${styles.thumb} ${i === detailImgIdx ? styles.thumbOn : ""}`} onClick={() => setDetailImgIdx(i)}>
              <SmartImg src={img} displayWidth={80} alt="" />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
